// Lib
import { handleActions } from 'redux-actions';

// Constants
import { ACTIVE, REJECTED } from 'constants/index';

// Actions
import {
  moveCandidateToStage,
  rejectUserCandidate,
  restoreRejectedCandidate,
  removeRecruiterCandidate,
  clearJobBoard,
} from 'modules/JobBoard/actions';
import { startEditNotesSubmit } from 'components/Modal/EditCandidatesNotes/actions';

import {
  setUserCandidates,
  setUserCandidate,
  updateCandidatePropById,
  setPendingCandidates,
} from './actions';

const archivedCandidates: any = [];
const pendingCandidates: any = [];
const userCandidates: any = [];

export const archivedCandidatesReducer = handleActions(
  {
    [setUserCandidates as any]: (state, action) =>
      action.payload.filter((candidate: any) => candidate.status === REJECTED),
    [restoreRejectedCandidate as any]: (state, { payload }: any) =>
      state.filter((candidate: any) => candidate.id !== payload.id),
    [rejectUserCandidate as any]: (state, { payload }) => [...state, payload.candidate],
    [clearJobBoard as any]: () => archivedCandidates,
  },
  archivedCandidates
);

export const pendingCandidatesReducer = handleActions(
  {
    [setPendingCandidates as any]: (_, action) => action.payload,
  },
  pendingCandidates
);

export const userCandidatesReducer = handleActions(
  {
    [setUserCandidates as any]: (_, action) =>
      action.payload.filter((candidate: any) => candidate.status === ACTIVE),
    [setUserCandidate as any]: (state, action) => {
      return [...state, action.payload];
    },
    [moveCandidateToStage as any]: (state, { payload }) =>
      state.map((candidate: any) => {
        const res = candidate;
        if (candidate.id === payload.candidateId) res.stageId = payload.stageId;
        return res;
      }),
    [rejectUserCandidate as any]: (state, { payload }) =>
      state.filter((candidate: any) => candidate.id !== payload.candidate.id),
    [removeRecruiterCandidate as any]: (state, { payload }) =>
      state.filter((candidate: any) => candidate.id !== payload.id),
    [restoreRejectedCandidate as any]: (state, { payload }) => [...state, payload],
    [clearJobBoard as any]: () => userCandidates,
    [startEditNotesSubmit as any]: (state, action) => {
      return [...state].map((candidate: any) => {
        if (candidate.id === action.payload.candidateId) {
          return { ...candidate, notes: action.payload.notes };
        }
        return candidate;
      });
    },
    [updateCandidatePropById as any]: (state, { payload }) => {
      return state.map((candidate: any) => {
        const res = candidate;
        if (candidate.id === payload.id) {
          return {
            ...candidate,
            [payload.propName]: payload.value,
          };
        }
        return res;
      });
    },
  },
  userCandidates
);
